export function getBaseUrl() {
    return window.location.href.split('?')[0];
}
